/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetRecruitersResponse } from '../../entities/v1/GetRecruitersResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1RecruiterModelSchema } from './recruiterModelSchema'
import { z } from 'zod'

export const v1GetRecruitersResponseSchema = z.object({
  recruiters: z.array(z.lazy(() => v1RecruiterModelSchema)),
}) as unknown as ToZod<V1GetRecruitersResponse>